import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 75746 75698"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#2b2a29;stroke-width:2126.54}.fil0{fill:#1c1b17;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M55497 60254c-5088 8606-14463 14381-25189 14381-16152 0-29245-13093-29245-29244 0-12714 8116-23531 19447-27560-2576 4356-4055 9435-4055 14861 0 16152 13093 29244 29245 29244 3437 0 6734-595 9797-1682zM60059 2503l3988 8503 9319 1166-6854 6421 1771 9223-8224-4535-8226 4535 1772-9223-6854-6421 9318-1166z"
        className="fil0 "
      />
      <path
        d="m46445 38739 1963 4186 4587 573-3373 3160 872 4542-4049-2233-4048 2233 872-4542-3374-3160 4587-573zM34296 15159l2425 5172 5667 708-4168 3905 1077 5610-5001-2758-5003 2758 1078-5611-4168-3904 5667-708z"
        className="fil0 "
      />
    </g>
  </svg>
)
export default SvgComponent
